import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl, AbstractControl, ValidationErrors } from '@angular/forms';
import { NavigationService } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import { AlertService } from 'services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ActiveUserSessionService } from 'services/activeusersession.service';
import { AuthenticationService } from 'services/authentication.service';
import { PasswordStrengthValidator } from 'app/shared/validators/password-strength.validators';
import { environment } from 'environments/environment';
import { MatDialog } from '@angular/material';
import { OtpVerificationComponent } from './otpverification/otpverification.component';
import { error } from 'console';
import { UserSessionService } from 'services/usersession.service';

interface SaIdDetails {
  dateOfBirth: Date;
  gender: 'male' | 'female';
  citizenship: 'citizen' | 'permanent_resident';
}


interface SaIdValidationResult {
  valid: boolean;
  error?: string;
  details?: SaIdDetails;
}

function validateSaId(id: string): SaIdValidationResult {
  if (!/^\d{13}$/.test(id)) {
    return { valid: false, error: 'ID must be exactly 13 digits' };
  }

  const yy = parseInt(id.slice(0, 2));
  const mm = parseInt(id.slice(2, 4));
  const dd = parseInt(id.slice(4, 6));
  const year = yy <= new Date().getFullYear() % 100 ? 2000 + yy : 1900 + yy;

  const dob = new Date(year, mm - 1, dd);
  const dobValid =
    dob.getFullYear() === year &&
    dob.getMonth() === mm - 1 &&
    dob.getDate() === dd;

  if (!dobValid) {
    return { valid: false, error: `Invalid date of birth: ${id.slice(0, 6)}` };
  }

  const digits = id.split('').map(Number);
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    if (i % 2 === 0) {
      sum += digits[i];
    } else {
      const doubled = digits[i] * 2;
      sum += doubled > 9 ? doubled - 9 : doubled;
    }
  }

  const expectedCheck = (10 - (sum % 10)) % 10;
  if (expectedCheck !== digits[12]) {
    return {
      valid: false,
      error: `Luhn checksum failed: expected ${expectedCheck}, got ${digits[12]}`,
    };
  }

  return {
    valid: true,
    details: {
      dateOfBirth: dob,
      gender: parseInt(id.slice(6, 10)) >= 5000 ? 'male' : 'female',
      citizenship: id[10] === '0' ? 'citizen' : 'permanent_resident',
    },
  };
}


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})

export class RegisterComponent implements OnInit {
  form: FormGroup;
  titleList: any[];
  dropdownSettings = {};
  fieldTextType: boolean;
  fieldConfirmTextType: boolean;
  productId: any;
  returnUrl: any;
  data: any;
  siteKey = environment.recaptcha.siteKey;
  recaptchaToken: string = null;
  showCaptcha = true;
  IsRecaptchaRequired = false;
  showeRecaptcha = true;
  encryptedUserId: any;
  localStorageProductId: any;
  isFromResellerPage: boolean = false;
  userId: any;
  resellerCode: any;

  constructor(private formBuilder: FormBuilder,
    private userService: UserService,
    private navigationService: NavigationService,
    private activeUserSessionService: ActiveUserSessionService,
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private alertService: AlertService, private router: Router,
    private userSessionService: UserSessionService,
    private dialog: MatDialog) {
    this.initializeValidators();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'Un Select All',
      itemsShowLimit: 4,
      allowSearchFilter: true
    };

    this.route.queryParams.subscribe(params => {
      this.productId = params["productId"];
      this.isFromResellerPage = params["Id"] === '1';

    });
    const productId = this.activeUserSessionService.getProductId();

    if (productId !== undefined && productId !== null) {
      this.localStorageProductId = productId;
    } else {
      this.localStorageProductId = 0;
    }
  }

  ngOnInit() {
    this.getTitleType(false);
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    //  this.form.controls['canUseDepartmentEmailAsUsername'].setValue(true);
    if (this.isFromResellerPage) {
      this.getResellerCode();
    }
    this.route.queryParams.subscribe(params => {
      if (params['userId']) {

        this.encryptedUserId = params['userId'];

        console.log('Encrypted User Id:', this.encryptedUserId);

        this.form.patchValue({
          encryptedUserId: this.encryptedUserId
        });
      }
    });
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      title: ['', [Validators.required]],
      firstName: ['', [Validators.required, Validators.pattern('.*\\S.*[a-zA-z ]')]],
      lastName: ['', [Validators.required, Validators.pattern('.*\\S.*[a-zA-z ]')]],
      // identificationNumber: ['', [Validators.required]],
      identificationNumber: ['', [Validators.required, this.saIdValidator.bind(this)]],
      mobileNumber: ['', [Validators.required,
      Validators.pattern('^[0-9]+$')
      ]], whatsAppNumber: [''],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, PasswordStrengthValidator, Validators.minLength(8)]],
      confirmpassword: ['', [Validators.required]],
      salesRepCode: [''],
      resellerCode: [''],
      encryptedUserId: ['']
    });
  }

  onSave() {

    debugger
    if (this.recaptchaToken == null) {
      this.IsRecaptchaRequired = true;
      return;
    }
    else
      this.IsRecaptchaRequired = false;

    if (this.form.value.mobileNumber) {
      if (this.form.value.mobileNumber.length < 9) {
        this.alertService.warning('Please enter valid cellphone number');
        this.showeRecaptcha = false;
        setTimeout(() => {
          this.showeRecaptcha = true;
        }, 100);
        return;
      }
      else if (this.form.value.mobileNumber.length == 10) {
        var mobile = this.form.value.mobileNumber[0];
        if (mobile != 0) {
          this.alertService.warning('Please enter valid cellphone number');
          this.showeRecaptcha = false;
          setTimeout(() => {
            this.showeRecaptcha = true;
          }, 100);
          return;
        }
      }
    }
    if (this.form.value.salesRepCode != '' && this.form.value.resellerCode != '') {
      this.alertService.warning('Please enter either Sales Rep Code or Reseller Code');
      this.showeRecaptcha = false;
      setTimeout(() => {
        this.showeRecaptcha = true;
      }, 100);
      return;

    }

    if (this.form.value.whatsAppNumber) {
      if (this.form.value.whatsAppNumber.length < 9) {
        this.alertService.warning('Please enter valid WhatsApp number');
        this.showeRecaptcha = false;
        setTimeout(() => {
          this.showeRecaptcha = true;
        }, 100);
        return;
      }
      else if (this.form.value.whatsAppNumber.length == 10) {
        var whatsAppNo = this.form.value.whatsAppNumber[0];
        if (whatsAppNo != 0) {
          this.alertService.warning('Please enter valid WhatsApp number');
          this.showeRecaptcha = false;
          setTimeout(() => {
            this.showeRecaptcha = true;
          }, 100);
          return;
        }
      }
    }

    if (this.form.valid) {
      debugger
      this.userService.save(this.form.value).subscribe(result => {
        if (result) {
          if (result.value > 0) {
            console.log('Registration successful, encryptedUserId :', this.encryptedUserId);
            if (this.encryptedUserId !== undefined && this.encryptedUserId !== null && this.encryptedUserId !== '') {


              this.navigationService.goToLogin();

              return;
            }
            else if (this.localStorageProductId != undefined && this.localStorageProductId != 0 && this.localStorageProductId !== '') {
              this.authService.login(this.form.value.email, this.form.value.password, null, true).subscribe((result) => {
                // this.router.navigate([this.returnUrl]);
                if (result) {
                  if ((result.isFailure)) {
                    this.navigationService.goToLogin();
                  }

                  else if (this.localStorageProductId != undefined && this.localStorageProductId != 0 && this.localStorageProductId !== '') {
                    this.navigationService.goToApplicationForm();
                  }
                }
              });
            }
            else {
              if (this.isFromResellerPage) {
                this.router.navigateByUrl('reseller-user-management')
              }
              else {
                this.navigationService.goToLogin();
              }
            }
            this.alertService.success('Registered successfully!');
            // this.navigationService.goToLogin();
          }
          else if (result.failures[0] != null) {
            this.alertService.warning(result.failures[0]);
          }
          else {
            this.alertService.warning('Something wrong your request not accepted');
          }
          // else if (result.failures[0] === "Email already exists") {
          //   this.alertService.warning('Email already exist');
          // }
          // else if (result.failures[0] === "Mobile Number already exists") {
          //   this.alertService.warning('Cellphone Number already exists');
          // }
          // else if (result.failures[0] === "The SalesRep Code is Invalid") {
          //   this.alertService.warning('The SalesRep Code is Invalid');
          // }
          // else if (result.failures[0] === "The Reseller Code is Invalid") {
          //   this.alertService.warning('The Reseller Code is Invalid');
          // }
        }
      });
    } else {
      this.validateFormControl();
    }
  }




  getTitleType(refresh) {
    try {
      this.userService.getTitleType(refresh).subscribe(result => {
        this.titleList = [];
        this.titleList = result;
        // console.log('this.weekDaysList', this.weekDaysList);
      });

    } catch (error) {

    }
  }
  onCancel() {
    if (this.isFromResellerPage) {
      this.router.navigateByUrl('reseller-user-management')
    }
    else {
      this.router.navigateByUrl('login');
    }
  }
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  toggleConfirmFieldTextType() {
    this.fieldConfirmTextType = !this.fieldConfirmTextType;
  }
  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

  titleChange(value) {

  }


  onCaptchaResolved(token: string) {
    this.recaptchaToken = token;
    console.log(this.recaptchaToken);

  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;

    if (input.value.length >= 9 &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete') {
      event.preventDefault();
      return;
    }

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  getResellerCode() {
    this.userId = this.userSessionService.userId();
    this.userService.getUserById(this.userId).subscribe((result: any) => {
      if (result) {
        this.resellerCode = result.resellerGroupCode;
        this.form.patchValue({
          resellerCode: this.resellerCode
        })
      }

    });

  }
  stripLeadingSpace(event: Event, controlName: string) {
    const input = event.target as HTMLInputElement;
    if (/^\s/.test(input.value)) {
      const trimmed = input.value.replace(/^\s+/, '');
      input.value = trimmed;
      this.form.get(controlName).setValue(trimmed, { emitEvent: false });
    }
  }

  saIdValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value.trim();

    if (!value) {
      return null; // required validator handles empty value
    }

    // Only validate SA ID if the value is exactly 13 digits
    if (/^\d{13}$/.test(value)) {
      const result = validateSaId(value);

      if (!result.valid) {
        return { invalidSaId: true };
      }
    }

    // Passport or any non-13-digit value is not affected
    return null;
  }

}


